module["exports"] = [
  "#{city_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr/address/city.js
 ** module id = 670
 ** module chunks = 0
 **/